export default "__VITE_ASSET__BtWlXydf__"